export default "__VITE_ASSET__B3cZCjzn__"